import React from "react";
import PageTitle from "../components/PageTitle";

function Bio() {
  return (
    <div>
      <PageTitle title="Bio" />
      <div className="pl-[5%] pr-[5%]">
        <p className="">
          Odontoiatria Sgarbini, lorem iipsum dolor sit amet, consectetur
          adipiscing elit. Nulla nec purus feugiat, vestibulum mi id, ultricies
          libero. Donec nec enim nec sem pharetra tincidunt. Vestibulum ante
          ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae;
        </p>
        <br />
        <p>
        Odontoiatria Sgarbini, lorem iipsum dolor sit amet, consectetur
          adipiscing elit. Nulla nec purus feugiat, vestibulum mi id, ultricies
          libero. Donec nec enim nec sem pharetra tincidunt. Vestibulum ante
          ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae;
        </p>
        <br />
        <p>
        Odontoiatria Sgarbini, lorem iipsum dolor sit amet, consectetur
          adipiscing elit. Nulla nec purus feugiat, vestibulum mi id, ultricies
          libero. Donec nec enim nec sem pharetra tincidunt. Vestibulum ante
          ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae;
        </p>
        <br />
        <p>
        Odontoiatria Sgarbini, lorem iipsum dolor sit amet, consectetur
          adipiscing elit. Nulla nec purus feugiat, vestibulum mi id, ultricies
          libero. Donec nec enim nec sem pharetra tincidunt. Vestibulum ante
          ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae;
        </p>
        <br />
        <p>
        Odontoiatria Sgarbini, lorem iipsum dolor sit amet, consectetur
          adipiscing elit. Nulla nec purus feugiat, vestibulum mi id, ultricies
          libero. Donec nec enim nec sem pharetra tincidunt. Vestibulum ante
          ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae;
        </p>
        <br />
        <p>
        Odontoiatria Sgarbini, lorem iipsum dolor sit amet, consectetur
          adipiscing elit. Nulla nec purus feugiat, vestibulum mi id, ultricies
          libero. Donec nec enim nec sem pharetra tincidunt. Vestibulum ante
          ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae;
        </p>
      </div>
    </div>
  );
}

export default Bio;
